import { useCurrentUser, useLocalStorage } from 'javascripts/hooks';

const useShowReportTemplateTooltip = () => {
  const currentUser = useCurrentUser();
  const [hasCreatedFirstReport, setHasCreatedFirstReport] = useLocalStorage(
    `hasCreatedFirstReport:${currentUser.id}`,
  );

  const [hasSeenFirstReportTooltip, setHasSeenFirstReportTooltip] =
    useLocalStorage(`hasShownFirstReportTooltip:${currentUser.id}`, false);

  const onTooltipClose = () => {
    setHasSeenFirstReportTooltip(true);
  };

  const onReportCreate = () => {
    setHasCreatedFirstReport(true);
  };

  return {
    onReportCreate,
    showReportTemplateTooltip:
      hasCreatedFirstReport && !hasSeenFirstReportTooltip,
    onTooltipClose,
  };
};

export default useShowReportTemplateTooltip;
